/*
  bfroz-header.js : port de la logique de _source/src/components/Header.tsx.
  - fond transparent → bg-chill-blue quand window.scrollY > 50 OU menu mobile ouvert
  - hamburger : bascule le panneau mobile, l'icône menu/x, aria-expanded ; un clic sur un lien referme
  - bouton panier : ouvre le tiroir (BFROZ.cart.open, ou événement bfroz:cart:open en repli)
*/
(function () {
  'use strict';

  var header = document.querySelector('[data-header]');
  if (!header) return;

  var toggle = header.querySelector('[data-menu-toggle]');
  var panel = header.querySelector('[data-menu-panel]');
  var iconOpen = header.querySelector('[data-menu-icon-open]');
  var iconClose = header.querySelector('[data-menu-icon-close]');
  var menuOpen = false;
  var scrolled = false;

  function paint() {
    var solid = scrolled || menuOpen;
    header.classList.toggle('bg-chill-blue', solid);
    header.classList.toggle('bg-transparent', !solid);
  }

  function onScroll() {
    scrolled = (window.scrollY || window.pageYOffset || 0) > 50;
    paint();
  }

  function setMenu(open) {
    menuOpen = open;
    if (panel) panel.classList.toggle('hidden', !open);
    if (iconOpen) iconOpen.classList.toggle('hidden', open);
    if (iconClose) iconClose.classList.toggle('hidden', !open);
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    paint();
  }

  if (toggle) {
    toggle.addEventListener('click', function () {
      setMenu(!menuOpen);
    });
  }
  if (panel) {
    panel.addEventListener('click', function (e) {
      if (e.target.closest('a')) setMenu(false);
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  onScroll();

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-open]');
    if (!btn) return;
    e.preventDefault();
    if (window.BFROZ && window.BFROZ.cart && window.BFROZ.cart.open) {
      window.BFROZ.cart.open();
    } else {
      document.dispatchEvent(new CustomEvent('bfroz:cart:open'));
    }
  });
})();
